import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.team || initialState;

export const selectTeam = createSelector([selectSlice], state => state);
